"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { ExamBoardConfig } from "@repo/exam-config";

/**
 * Makes the request's resolved exam board available to client components.
 * The board is resolved on the server (from host / override) in the root layout
 * and passed down here, so the whole client tree can read it synchronously via
 * useBoard() instead of hardcoding "TMUA".
 */
const BoardContext = createContext<ExamBoardConfig | null>(null);

export function BoardProvider({
  board,
  children,
}: {
  board: ExamBoardConfig;
  children: ReactNode;
}) {
  return <BoardContext.Provider value={board}>{children}</BoardContext.Provider>;
}

export function useBoard(): ExamBoardConfig {
  const board = useContext(BoardContext);
  if (!board) {
    throw new Error("useBoard must be used within a BoardProvider");
  }
  return board;
}
